import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UtilsService {

    /** Adiciona zeros a esquerda com base na quantidade informada no parâmetro size */
    leftPad(num: number, size: number) {
        return leftPad(num, size);
    }
}

// Function exportada para poder ser utilizada em classes sem a DI (Dependency Injection)
/** Adiciona zeros a esquerda com base na quantidade informada no parâmetro size */
export function leftPad(num: number, size: number) {
    if (num == null || num === undefined) {
        return '';
    }

    let s = num + '';
    while (s.length < size) {
        s = '0' + s;
    }
    return s;
}
